var _style, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtBurgerClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 74 85",
    style: {
      enableBackground: "new 0 0 74 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000019650861109372679760000005164677538146092955_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 15,
    y: 20.5,
    width: 44,
    height: 44
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096738903666569857400000002456585828772576176_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_close-black",
    style: {
      clipPath: "url(#SVGID_00000096738903666569857400000002456585828772576176_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2_export",
    transform: "translate(-8.782 -8.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 36.1,
    y: 13.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -19.1874 39.2474)",
    width: 3.3,
    height: 59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2_Copy",
    x: 8.3,
    y: 41.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -19.1853 39.2467)",
    width: 59,
    height: 3.3
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtBurgerClose);
export default __webpack_public_path__ + "static/media/bt_burger_close.6c87569086fcf10c44b372abc141ebc7.svg";
export { ForwardRef as ReactComponent };